PJQ.views.timecards = {};

PJQ.constants.timecards = {
    view: {
        BY_TIMECARD: "timecard",
        BY_TIMECARD_GROUP: "timecard-group",
        BY_PROJECT: "project",
        BY_PROJECT_CONTACT: "project-contact",
        BY_PROJECT_CONTACT_TIMECARD: "project-contact-timecard",
        BY_CONTACT: "contact",
        BY_CONTACT_PROJECT: "contact-project",
        BY_CONTACT_PROJECT_TIMECARD: "contact-project-timecard",
        BY_TIMECARD_DATAENTRY: "timecard-dataentry",
        BY_TIMECARD_GROUP_DATAENTRY: "timecard-group-dataentry",
        PROJECTWALL_BY_TIMECARD: "projectwall-timecard"
    },
    defaultDateRange: {
        WEEK_TO_DATE: 0,
        DAYS_7: 7,
        DAYS_14: 14,
        DAYS_28: 28,
        MONTH_TO_DATE: -1
    },
    selectionMode: {
        NONE: 0,
        APPROVE: 1,
        UNAPPROVE: 2
    },
    manageTimeCards: {
        stage: {
            SELECT_DATE: 0,
            SELECT_PROJECT: 1,
            SELECT_CONTACTS: 2,
            MANAGE_TIMECARDS: 3
        }
    },
    timeCardGroupBy: {
        CONTACT: 'contact',
        DATE: 'date'
    }
};

PJQ.helpers.timecards = {};

if (PJQ.app.module === PJQ.constants.modules.TIMECARDS) {
    PJQ.app.addOldRoutes([
        {
            route: '',
            name: 'default',
            callback: function () {
                PJQ.app.router.navigate('timecards', {
                    trigger: true,
                    replace: true
                });
            }
        }
    ]);
}

PJQ.modules.timecards = {
    routes: [
        {
            route: 'timecards',
            name: 'timecards',
            callback: function () {
                PJQ.app.session.project = null;
                if (PJQ.app.module === PJQ.constants.modules.APP) {
                    if (PJQ.app.session.get('ownsPortal')) {
                        PJQ.app.initNavigator({
                            activeItem: "timecards"
                        });
                    }
                    else {
                        PJQ.app.initNavigator();
                    }
                }
                else {
                    PJQ.app.view.renderView(PJQ.views.timecards.TimeCardMain);
                }
            }
        },
        {
            route: 'projects/:projectId/timecards',
            name: 'timecardsProject',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "timecardsProject");
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.timecards.routes);

